import { ID } from '@griply/types';

// One rendered row: an item linked to several goals renders under each of them.
export type SectionItemRef = {
  sectionId: ID;
  itemId: ID;
};

const SEPARATOR = '/';

export const createSectionItemId = (sectionId: ID, itemId: ID): ID =>
  `${sectionId}${SEPARATOR}${itemId}`;

export const parseSectionItemId = (
  occurrenceId: ID | number,
): SectionItemRef | undefined => {
  const id = occurrenceId.toString();
  const separatorIndex = id.indexOf(SEPARATOR);
  if (separatorIndex === -1) {
    return undefined;
  }
  return {
    sectionId: id.slice(0, separatorIndex),
    itemId: id.slice(separatorIndex + 1),
  };
};
